/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

import CustomInput from 'components/layout/CustomInput';
import CustomButton from 'components/layout/CustomButton';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const Container = styled.div`
  padding: 70px;

  .celphone,
  .inputEmail {
    margin-top: 16px;
  }

  @media (max-width: 959px) {
    padding: 20px;
  }
`;

export const WrapInputName = styled.div`
  display: flex;
  .name,
  .lastName {
    width: 220px;

    @media (max-width: 959px) {
      width: 100%;
    }
  }

  .lastName {
    margin-left: 8px;
  }

  @media (max-width: 959px) {
    width: 99%;
  }
`;

export const InputCond = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const InputDoc = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonNext = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonBack = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonText = styled.p`
  display: flex;
  justify-content: center;
  margin-right: 42px;
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #0b24fb;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 29px;
  color: #7a7a7a;
  max-width: 538px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  margin-top: 57px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  button {
    + button {
      margin-top: 16px;
    }
  }
`;

export const Spinner = styled(AiOutlineLoading3Quarters)`
  animation: spinerAnimate 1.5s linear infinite;
`;
